// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { CveRetestJobSchema } from './CveRetestJobSchema';

/////////////////////////////////////////
// CVE RETEST JOB RELATION SCHEMA
/////////////////////////////////////////

export type CveRetestJobRelations = {
  surface: ExternalNetworkWithRelations;
};

export type CveRetestJobWithRelations = Omit<z.infer<typeof CveRetestJobSchema>, "matchedSoftware"> & {
  matchedSoftware?: JsonValueType | null;
} & CveRetestJobRelations

export const CveRetestJobWithRelationsSchema: z.ZodType<CveRetestJobWithRelations> = CveRetestJobSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
}))